import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHomeCircle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconHomeCircle"><Path fillRule="evenodd" clipRule="evenodd" d="M11.1268 1.63734C11.6673 1.32613 12.3327 1.32613 12.8732 1.63734L20.1232 5.81158C20.6657 6.12392 21 6.70221 21 7.32817V19.25C21 20.2165 20.2165 21 19.25 21H4.75C3.7835 21 3 20.2165 3 19.25V7.32817C3 6.70221 3.33434 6.12392 3.87681 5.81158L11.1268 1.63734ZM8.75 12.25C8.75 10.4551 10.2051 9 12 9C13.7949 9 15.25 10.4551 15.25 12.25C15.25 14.0449 13.7949 15.5 12 15.5C10.2051 15.5 8.75 14.0449 8.75 12.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHomeCircle;
